//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import { IAngularEvent, IRootScopeService } from 'angular';

import { IUiaModalClosedResponse } from '@legacy-components/common/universal-image-actions/models/events';

import getAngularInjector from '../getAngularInjector';
import PartialCuid from '@models/PartialCuid';

const ANGULAR_ROOTSCOPE_SERVICE_NAME = '$rootScope';
type IRootScopeListener = (event: IAngularEvent, ...args: any[]) => any;

export function broadcastRootScopeEvent(name: string, ...args: any[]) {
  const angularRootscopeService: IRootScopeService = getAngularInjector().get(
    ANGULAR_ROOTSCOPE_SERVICE_NAME,
  );
  return angularRootscopeService.$broadcast(name, ...args);
}

function setupRootScopeWatcher(name: string, listener: IRootScopeListener) {
  const angularRootscopeService: IRootScopeService = getAngularInjector().get(
    ANGULAR_ROOTSCOPE_SERVICE_NAME,
  );
  return angularRootscopeService.$on(name, listener);
}

export function addUiaCloseListener(
  handler: (UiaModalClosedResponse: IUiaModalClosedResponse) => void,
) {
  return setupRootScopeWatcher('uia:modal:closed', (_, closeResponse) =>
    handler(closeResponse),
  );
}

export function addUniversalUploadListener(
  handler: (UniversalUploadResponse) => void,
) {
  return setupRootScopeWatcher(
    'universal-upload:content-uploaded',
    (_, uploadResponse) => handler(uploadResponse),
  );
}

export const addUiaRemoveItemsFromLibraryListener = (
  handler: (UiaRemoveItemsFromLibraryResponse: {
    items: PartialCuid[];
  }) => void,
) => {
  return setupRootScopeWatcher(
    'uia:remove-items-from-library',
    (_, removeItemsFromLibraryResponse) =>
      handler(removeItemsFromLibraryResponse),
  );
};

export const addSchedulerVideosFinishedProcessingListener = (
  handler: (SchedulerVideosFinishedProcessingResponse: string[]) => void,
) => {
  return setupRootScopeWatcher(
    'scheduler:videos-finished-processing',
    (_, schedulerVideosFinishedProcessingResponse) =>
      handler(schedulerVideosFinishedProcessingResponse),
  );
};
